import styled from '@emotion/styled'

// Interface for styled component props
interface LoaderOverlayProps {
  useParentSize?: boolean
}

export const LoaderOverlay = styled.div<LoaderOverlayProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 800;
  opacity: 0;
  transition: opacity 0.2s;

  ${(props) =>
    props.useParentSize
      ? `
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    `
      : `
        position: relative;
        height: 10rem;
        width: 100%;
    `}

  &.visible {
    opacity: 1;
  }
`
